module.exports = __webpack_public_path__ + "img/3.2ee8979b.png";